import { useState, useEffect } from 'react';

import { _TaxSchemeValue } from '../../../../../core/services/dataBean/EntityCatalog';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const TaxSchemeValueConstantsEditor = ({ idSelector, onChange, label }: Props) => {

    const taxScheme = useDataBean(_TaxSchemeValue)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector >= 0) {
            setID(idSelector);
        }
        getLista();
    }, [])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        taxScheme.instance.getTaxSchemeValueConstants(null).then(
            (resp) => {
                setLista(resp)
                // if (resp.length > 0 && !idSelector) {
                //     setID(resp[0].DataBeanProperties.IDAppointment)
                // }
            }
        )
    }

    return (
        <>
            <label>{label ?? "Tipo de Impuesto"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}